<template>
  <div :class="{ 'has-logo': showLogo }">
    <div class="icon">
      <img class="logo" src="@/assets/images/menu/logo.png" alt />
      <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
        router>
        <sidebar-item v-for="route in activePermissionRoutes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem.vue";
import variables from "@/styles/variables.scss";
import Hamburger from "@/components/Hamburger/index.vue";

export default {
  components: { SidebarItem, Hamburger },
  computed: {
    activePermissionRoutes() {
      return this.$store.getters.permissionRoutes;
    },
    sidebar() {
      return this.$store.getters.sidebar;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return false;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
  },
};
</script>
